import { Injectable } from "@angular/core";
import { Subscription } from "rxjs";

@Injectable()
export abstract class UnsubscribeAll {
    /**
     *  @deprecated
     * 
     * use `takeUntilDestroyed()` from `@angular/core/rxjs-interop` instead
     * ~~~typescript
     * // BAD
     * class MyComponent extends UnsubscribeAll implements OnDestroy {
     *      myFunction(){
     *          const sub = ready$.subscribe(() => {...});
     *          subs.push(sub);
     *      }
     *  
     *      ngOnDestroy(): void {
     *          this.unsubscribeAll();
     *      }
     * }
     * 
     * // GOOD
     * class MyComponent {
     *      private _destroyRef = inject(DestroyRef);
     * 
     *      myFunction(){
     *          ready$
     *              .pipe(takeUntilDestroyed(this.destroyRef))
     *              .subscribe(() => {...});
     *      }
     * }
     * ~~~
     */
    public subs: Subscription[];
    constructor() {
        this.subs = [];
    }

    unsubscribeAll() {
        this.subs.forEach(sub => {
            if (sub && sub instanceof Subscription) {
                sub.unsubscribe();
            } else {
                this.subs.splice(this.subs.indexOf(sub), 1);
            }
        });
    }

    /** 
     * ```  
     * ngOnDestroy(): void {
     *     this.unsubscribeAll();
     * }
     * ``` 
     * */
    abstract ngOnDestroy(): void;

}
